/*
* @Author: babysoft08
* @Date:   2025-09-09 12:57:27
* @Last Modified by:   babysoft08
* @Last Modified time: 2025-09-22 22:42:33
*/
import React from 'react';
import moment from 'moment';
import './NetPricing.css';
import { API_URL } from '../../constants.js';
import { multiplierData } from './MultiplierData';
import GearSpinner from '../../components/GearSpinner/GearSpinner';
import Loader from './../../components/Loader/Loader';
import printIcon from '../../images/print-img.png';
import shareIcon from '../../images/share-img.png';
import pdfIcon from '../../images/pdf-img.png';
import xlsIcon from '../../images/xls-img.png';
import { Validation } from '../../validation';
import NetPriceService from './../../services/NetPriceService/NetPriceService';

class NetPricingReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      multipliers: {},
      showSpinner: true,
      showLoader: false,
      isShowMessageModal: false,
      isShowShareModal: false,
      fields: {},
      errors: {},
      succeess_message:'',
      error_message:'',
      isLoadingModal: false
    };
    this.renderMessageModal = this.renderMessageModal.bind(this);
    this.renderShareModal = this.renderShareModal.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.netPriceService = new NetPriceService();
  }

  componentDidMount() {
    if (localStorage.getItem('techtop_user_id')) {
      this.setState({
        user_id: localStorage.getItem('techtop_user_id'),
        first_name: localStorage.getItem('techtop_user_first_name'),
        last_name: localStorage.getItem('techtop_user_last_name'),
        company: localStorage.getItem('techtop_user_company'),
        company_logo: localStorage.getItem('techtop_user_company_logo'),
        phone: localStorage.getItem('techtop_user_phone'),
        cell_phone: localStorage.getItem('techtop_user_cell_phone'),
        direct_phone: localStorage.getItem('techtop_user_direct_phone'),
        fax: localStorage.getItem('techtop_user_fax'),
        address: localStorage.getItem('techtop_user_address'),
        state: localStorage.getItem('techtop_user_state'),
        city: localStorage.getItem('techtop_user_city'),
        zip: localStorage.getItem('techtop_user_zip'),
        is_login: 1
      });

      if (localStorage.getItem('techtop_user_multiplier')) {
        this.setState({
          multipliers: JSON.parse(localStorage.getItem('techtop_user_multiplier')),
          showSpinner: false
        });
      }
    }
  }

  printReport() {
  	const originalTitle = document.title;
    const formattedDate = moment().format('MM/DD/YYYY HH:mm');
    document.title = `netprice-report-${formattedDate}`;
    window.print();
    document.title = originalTitle;
  };

  downloadPDF = async () => {
    const { user_id } = this.state;
    this.setState({showLoader : true});
    try {
        // The email value is used in BE for reporting purposes when failed to download datasheet.
        const response = await fetch(
          `${API_URL}/export-netprice-pdf/${user_id}`
        );
        if (!response.ok) throw new Error('Failed to fetch datasheet');
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        const formattedDate = moment().format('MM/DD/YYYY HH:mm');
        const title = `netprice-report-${formattedDate}`;
        link.href = url;
        link.download = `${title}.pdf`;
        link.click();
        window.URL.revokeObjectURL(url);
        this.setState({showLoader : false});
      } catch (error) {
        console.error('Error downloading datasheet:', error);
        this.setState({showLoader : false});
      }
  };

  downloadExcel = async () => {
    const { user_id } = this.state;
    this.setState({showLoader : true});
    try {
        // The email value is used in BE for reporting purposes when failed to download datasheet.
        const response = await fetch(
          `${API_URL}/export-netprice-excel/${user_id}`
        );
        if (!response.ok) throw new Error('Failed to fetch datasheet');
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        const formattedDate = moment().format('MM/DD/YYYY HH:mm');
        const title = `netprice-report-${formattedDate}`;
        link.href = url;
        link.download = `${title}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(url);
        this.setState({showLoader : false});
      } catch (error) {
        console.error('Error downloading datasheet:', error);
        this.setState({showLoader : false});
      }
  };

  getMultiplier(multiplier) {
    let multiplier_value = 'Not Set';
    if (multiplier) {
      const { multipliers } = this.state;
      const found = multipliers.find((data) => data.multiplier_group === multiplier);
      if (found) {
        multiplier_value = found.customer_multiplier;
      }
    }
    return multiplier_value;
  }

  renderMultiplierTable() {
    return (
      <React.Fragment>
        {multiplierData.length > 1 ? (
          multiplierData.map((value, index) => {
            const pageKeys = Object.keys(value.page).sort((a, b) => {
              const getStartPage = (key) => parseInt(key.split('-')[0], 10);
              return getStartPage(a) - getStartPage(b);
            });

            return pageKeys.map((value2, index2) => (
              <tr key={`${index}-${index2}`}>
                {index2 === 0 && (
                  <>
                    <td rowSpan={pageKeys.length}>{value.multiplier_code}</td>
                    <td rowSpan={pageKeys.length}>{this.getMultiplier(value.multiplier_code)}</td>
                  </>
                )}
                <td>{value2}</td>
                <td>{value.page[value2]}</td>
              </tr>
            ));
          })
        ) : (
          <tr>
            <td colSpan="4">No data found.</td>
          </tr>
        )}
      </React.Fragment>
    );
  }

  handleChange(field, e){
    let { fields } = this.state; 
    const { name, value } = e.target;
        const newFormData = {
            ...fields,
            [name]: value,
        };
        this.setState({fields : newFormData, errors: {}});
  }

  handleSubmit(e) {
    e.preventDefault(); // ✅ stop page refresh

    let { fields } = this.state;
    let errors = Validation(fields, ['email']);
    if (Object.keys(errors).length > 0) {
      this.setState({ errors: errors });
      return;
    }
    this.submitShare();
  }

  submitShare() {
    const { fields, user_id } = this.state;
    // merge user_id into fields
    const payload = {
      ...fields,
      user_id: user_id,
    };
    this.setState({isShowShareModal:false, isShowMessageModal:true, isLoadingModal: true});
    this.netPriceService.shareNetpriceExcel(payload).then(response => {
      this.setState({ isLoadingModal: false });
      if (response.data.response === 'success') {
        this.setState({success_message : response.data.message});
      } else {
        this.setState({error_message : response.data.message});

      }
      setTimeout(() =>{
        this.setState({success_message : '', error_message :'', fields :{}, errors : {}, isShowMessageModal:false});
      },6000);
    });

    
    console.log("📤 Submitting data:", payload);
    // Your API call or logic here
  }

  renderShareModal() {
    let { isShowShareModal, errors, success_message, error_message } = this.state;
    return(
      <React.Fragment>
        {isShowShareModal && (
          <React.Fragment>
            <div className="motor-modal-overlay">
              <div className="motor-modal-content">
                <form className="motor-error-report-form d-flex flex-column gap-3" method="post" onSubmit={this.handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="part_number">Email</label>
                    <input type="text" className="form-control" id="email" ref="email" name="email" onChange={this.handleChange.bind(this, "email")}/>
                    {errors.email && <div className="text-danger">{errors.email}</div>}
                  </div>
                  <div className="d-flex w-100 justify-content-evenly gap-4">
                    <button type="button" className="btn btn-secondary w-50 m-0 rounded" onClick={() => this.setState({ isShowShareModal: false, fields: {}, errors: {} })}> Close </button>
                    <button type="submit" className="submit-button w-50 m-0 rounded submit-error-report"> Share </button>
                            </div>
                </form>
              </div>
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    )
  }

  renderMessageModal() {
    let { isShowMessageModal, errors, success_message, error_message, isLoadingModal } = this.state;
    return(
      <React.Fragment>
        {isShowMessageModal && (
          <React.Fragment>
            <div className="motor-modal-overlay">
              <div className="motor-modal-content text-center">
                {isLoadingModal ? (
                    <React.Fragment>
                      <GearSpinner/>
                    </React.Fragment>
                  )
                  :(
                    <React.Fragment>
                      {(success_message !== '') && (
                        <h6 style={{ color:'green' }}>{success_message}</h6>
                      )}
                      {(error_message !== '') && (
                        <h6 style={{ color:'red' }}>{error_message}</h6>
                      )}
                    </React.Fragment>
                  )
                }
              </div>
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    )
  }

  render() {
    const { company, showSpinner, showLoader } = this.state;

    return (
      <main className="techtop-middle-div">
        {this.renderShareModal()}
        {this.renderMessageModal()}
        <section className="techtop-net-pricing-report-section pb-5">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="techtop-default-title2">
                  <div className="row">
                    <div className="col-6">
                      <h1 className="m-0 dark-color1">Net Pricing Report</h1>
                    </div>
                    <div className="col-6">
                      <h2 className="m-0 dark-color1 text-end">{company}</h2>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-9">
                    <div id="print-section">
                      <div className="col-md-12 mt-3">
                        <h4 className="dark-color1 text-center">Net Pricing Report Prepared for</h4>
                        <h3 className="dark-color1 text-center">{company}</h3>
                        <div className="table-responsive">
                          <table className="table table-bordered text-center" id="techtop-net-pricing-report-table">
                            <thead>
                              <tr>
                                <th>Multiplier Code</th>
                                <th>Discount Multiplier</th>
                                <th>Pages</th>
                                <th>Motor Line Descriptions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {showSpinner ? (
                                <tr>
                                  <td colSpan="4">
                                    <GearSpinner />
                                  </td>
                                </tr>
                              ) : (
                                this.renderMultiplierTable()
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-3 mt-3">
                    <ul className="net-pricing-report-list no-print">
                      <li>
                        <a
                          href='#'
                          onClick={this.printReport}
                        >
                          <img src={printIcon} alt="Print" /> Print
                        </a>
                      </li>
                      <li>
                        <a href="#" onClick={(e) => {
                            e.preventDefault(); // prevent page reload on anchor click
                            this.setState({ isShowShareModal: !this.state.isShowShareModal });
                          }}>
                          <img src={shareIcon} alt="Share" /> Share
                        </a>
                      </li>
                      <li>
                        <a href="#" onClick={this.downloadPDF}><img src={pdfIcon} alt="Export PDF" />Export PDF</a>
                      </li>
                      <li>
                        <a href="#" onClick={this.downloadExcel}><img src={xlsIcon} alt="Export Excel" />Export Excel</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Loader isLoading={showLoader} message="Processing..."/>
      </main>
    );
  }
}

export default NetPricingReport;